var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"col-md-12 mt-3 pl-3 none_gauge"},[_c('iframe',{ref:"iframe",staticClass:"w-100 h-100",attrs:{"src":"http://new.wanfangdata.com.cn/index.html","frameborder":"0"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }